/**
 * useAuth — convenience hook exposing auth state and actions.
 */

import { useAuthContext } from '@/contexts/AuthContext';
import { logoutUser } from '@/services/authService';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { isAdmin, canManageUsers, canViewAuditLogs, canViewDashboard } from '@/utils/permissionUtils';

export function useAuth() {
  const { firebaseUser, cmsUser, loading, error, refreshUser } = useAuthContext();
  const navigate = useNavigate();

  const logout = async () => {
    try {
      await logoutUser();
      navigate('/login', { replace: true });
    } catch {
      toast.error('Failed to sign out. Please try again.');
    }
  };

  return {
    // State
    firebaseUser,
    cmsUser,
    loading,
    error,
    isAuthenticated:  !!firebaseUser,
    isApproved:       cmsUser?.status === 'approved',
    isPending:        cmsUser?.status === 'pending',
    isRejected:       cmsUser?.status === 'rejected',
    isDeactivated:    cmsUser?.status === 'deactivated',

    // Derived permission flags
    isAdmin:          isAdmin(cmsUser),
    canManageUsers:   canManageUsers(cmsUser),
    canViewAuditLogs: canViewAuditLogs(cmsUser),
    canViewDashboard: canViewDashboard(cmsUser),

    // Actions
    logout,
    refreshUser,
  };
}
